import { createStore, applyMiddleware, compose } from 'redux';
// import { createLogger } from 'redux-logger';
// import thunk from 'redux-thunk';
import rootReducer from './reducers';

// const middlewares = [thunk];

// if (process.env.NODE_ENV !== 'production') {
// 	const logger = createLogger({ collapsed: true, diff: true });
// 	middlewares.push(logger);
// }

export default function configureStore() {
	return createStore(
		rootReducer,
		window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ () : f => f
	);
}
